export default {
  selected: 'Vybráno',
  deselect_all_selected_options: 'Zrušit výběr všech vybraných možností',
  expanded: 'Rozbaleno',
  collect: 'Sbírat',
  no_options_available: 'Žádné možnosti k dispozici',
  required: 'Vyžadováno',
  input_clear_aria_label: 'Vymazat vstup',
  input_show_hide_password_aria_label: 'Zobrazit nebo skrýt heslo',
  input_increment_aria_label: 'Zvýšit hodnotu',
  input_decrement_aria_label: 'Snížit hodnotu',
  english: 'Angličtina',
  chinese: 'Čínština',
  portuguese: 'Portugalština',
  spanish: 'Španělština',
  dutch: 'Holandština',
  french: 'Francouzština',
  german: 'Němčina',
  russian: 'Ruština',
  ukrainian: 'Ukrajinština',
  korean: 'Korejština',
  italian: 'Italština',
  czech: 'Čeština',
  access_your_account: 'Přístup k vašemu účtu',
  use_your_company_credentials_to_get_started:
    'Pro začátek použijte přihlašovací údaje vaší společnosti',
  this_link_has_expired: 'Tento odkaz vypršel',
  login: 'Přihlásit se',
  sample_no_production_date_message: 'Je nutné zvolit datum výroby.',
  free_comment: 'Volný komentář',
  save_comments: 'Uložit & Zavřít',
  round_list_rounds: 'Kola',
  round_edit_round: 'Upravit kolo',
  round_new_round: 'Nové kolo',
  round_remove_round: 'Jste si jisti, že chcete kolo smazat',
  round_schedule: 'Plán',
  round_tasters_unselect_all: 'Zrušte výběr všech ochutnávačů',
  round_tasters_select_all: 'Vybrat všechny degustátory',
  round_close: 'Zavřít kolo',
  round_close_message: 'Jste si jisti, že chcete kolo ukončit',
  round_create_site_message: 'Vytváříte kolo, které není pro vaší lokalitu',
  round_closed_message: 'Uzavřená kola nelze upravovat',
  round_status_created: 'Vytvořeno',
  round_status_samples: 'Vzorky',
  round_status_scheduled: 'Naplánované',
  round_status_tasters: 'Degustátoři',
  round_status_in_progress: 'Probíhající',
  round_status_finished: 'Dokončeno',
  round_status_closed: 'Uzavřeno',
  round_schedule_start_finish_date:
    'Datum zahájení nesmí být větší než datum ukončení!',
  round_schedule_finish_date_no_start_date:
    'Nejprve musíte vybrat Datum zahájení!',
  round_disabled_discussion_tooltip:
    'Nemůžete přejít na Diskuzi nedokončeného kola',
  round_up_down_maintenance_tooltip:
    'Tato funkce je v údržbě a dočasně není k dispozici',
  round_delete_other_users_rounds:
    'Nemáte oprávnění odstranit kolo, které jste nevytvořili vy sami',
  round_randomize_samples_order_button: 'Zamíchat',
  round_block_results_tooltip:
    'Uzamknout výsledky tohoto kola před stahováním na obrazovce přehledů. Pokud je tlačítko deaktivováno, nemáte oprávnění uzamknout výsledky kola z tohoto umístění.',
  round_block_results_confirm:
    'Jste si jisti, že chcete zablokovat/odblokovat výsledky kola ',
  round_block_results_no_privilege:
    'Nemáte oprávnění blokovat/odblokovat výsledky kola z tohoto umístění.',
  sample_list_samples: 'Vzorky',
  sample_edit_sample: 'Upravit vzorek',
  sample_new_sample: 'Nový vzorek',
  sample_remove_sample: 'Odstranit vzorek',
  sample_upload_document: 'Nahrát dokumenty',
  sample_download_documents: 'Vzorové dokumenty',
  sample_tasted_dates: 'Datum ochutnávky',
  sample_upload_message:
    'Chcete-li nahrát více dokumentů, přidejte je do složky ',
  sample_not_for_kpi: 'Ne pro KPI',
  sample_package: 'Balíček',
  sample_volume: 'Objem',
  sample_production_date: 'Datum výroby',
  sample_expire_date: 'Datum expirace',
  sample_trial_identifier: 'Identifikátor zkoušky',
  sample_project_name: 'Název projektu',
  sample_linked: 'Souvisí s kolem',
  sample_expire_bigger_than_production:
    'Datum výroby nesmí být větší než datum expirace',
  sample_no_site_message:
    'Pro vytvoření vzorku je povinné vybrat Zónu, Zemi a Místo.',
  sample_no_brand_message: 'Je povinné vybrat značku (Brand).',
  sample_duplicated_kpi_message:
    'Pro vybrané čtvrtletí, značku a web již existuje KPI a nebude možné uložit.',
  sample_duplicated_kpi_message_quarter:
    'Pro vybrané čtvrtletí, značku a web již existuje KPI a nebude možné uložit.',
  sample_duplicated_project_message:
    'Pro tuto lokalitu a značku již existuje vzorek s tímto názvem projektu a identifikátorem zkoušky a nebude možné jej uložit.',
  sample_project_no_name_or_trial:
    'Název projektu a Identifikátor zkoušky jsou při vytváření vzorku typu projektu povinné.',
  sample_production_to_project_confirm_message:
    'Měníte typ tohoto vzorku z PRODUCTION na PROJECT. Přejete si pokračovat?',
  sample_project_to_production_confirm_message:
    'Měníte typ tohoto vzorku z PROJECT na PRODUCTION. Přejete si pokračovat?',
  sample_no_volume_message:
    'Balení a Objem jsou povinné při vytváření/úpravě vzorku.',
  sample_id_code_message: 'Uveďte prosím úplné číslo šarže',
  sample_show_all_samples_hint:
    'Zobrazení vzorků vytvořených do šesti měsíců ode dneška. Pokud chcete zobrazit i starší vzorky, zaškrtněte toto políčko.',
  sample_show_all_samples_label: 'Zobrazit všechny vzorky',
  package_duplicate: 'Balení s tímto názvem již existuje',
  common_production: 'Výroba',
  common_project: 'Projekt',
  group_list_groups: 'Skupiny',
  group_edit_group: 'Upravit skupinu',
  group_new_group: 'Nová skupina',
  group_remove_group: 'Odstranit skupinu',
  group_close_modal: 'Zavřít',
  group_duplicated_user: 'Tento uživatel již byl přidán do této skupiny!',
  group_no_name_message: 'Je nutné zadat název skupiny',
  group_no_zone_message: 'Je nutné vybrat zónu',
  group_no_users_message: 'Je nutné vybrat alespoň jednoho ochutnávače',
  family_list_families: 'Styly',
  family_edit_family: 'Upravit styl',
  family_new_family: 'Nový styl',
  family_remove_family: 'Odebrat styl',
  families_page_description:
    'Spravujte všechny styly a jejich konfigurace na jednom místě',
  family_new_page_description:
    'Vyplňte informace o stylu a dokončete vytvoření.',
  family_edit_page_description: 'Upravit informace o stylu.',
  family_save_success: 'Styl byl úspěšně vytvořen!',
  family_update_success: 'Styl byl úspěšně aktualizován!',
  family_save_failed: 'Styl se nepodařilo uložit.',
  family_save_success_desc: 'Zkontrolujte to ve stylech níže.',
  family_update_success_desc: 'Zkontrolujte to ve stylech níže.',
  family_save_failed_desc: 'Zkuste to prosím za chvíli znovu.',
  the_name_is_duplicated: 'Název je duplicitní.',
  common_style_name: 'Název stylu',
  common_warning: 'Varování',
  cancel_new_family_title: 'Zrušit nový styl?',
  cancel_edit_family_title: 'Zrušit úpravu stylu?',
  cancel_new_family_confirm: 'Zrušit nový styl',
  cancel_edit_family_confirm: 'Zrušit úpravu stylu',
  family_remove_success: 'Styl byl úspěšně odstraněn',
  family_remove_failed: 'Styl se nepodařilo odstranit',
  family_delete_title: 'Smazat styl?',
  family_delete_description:
    'Styl {{name}} bude trvale odstraněn. Jste si jisti, že chcete pokračovat?',
  family_delete_success: 'Styl byl úspěšně smazán!',
  family_delete_success_desc: 'Styl byl odstraněn.',
  family_delete_failed: 'Styl se nepodařilo smazat.',
  family_delete_failed_desc: 'Zkuste to prosím za chvíli znovu.',
  family_has_no_english_name:
    'Pozor: název stylu musí být povinně v angličtině',
  brand_list_brands: 'Značky',
  brand_edit_brand: 'Upravit značku',
  brand_new_brand: 'Nová značka',
  brand_remove_brand: 'Odstranit značku',
  brand_profile_picture: 'Nahrát profilový obrázek piva',
  brand_upload_brand_logo: 'Nahrát logo značky',
  brand_duplicate: 'Varování: Existuje pivo s tímto názvem',
  brand_has_no_english_name:
    'Musíte mít alespoň jeden název značky a k němu odpovídající profil značky.',
  brand_upload_help_message: 'Pouze soubory PNG a JPG',
  brand_has_no_product_type: 'Musíte vybrat typ produktu',
  package_list_packages: 'Balení',
  package_edit_package: 'Upravit balení',
  package_new_package: 'Nové balení',
  package_remove_package: 'Odebrat balení',
  packages_page_description:
    'Spravujte všechny typy balení a jejich konfigurace na jednom místě.',
  comments_page_description:
    'Spravujte všechny atributy a jejich konfigurace na jednom místě.',
  comments_new_page_description:
    'Vyplňte informace o atributu a dokončete vytvoření.',
  comments_edit_page_description:
    'Upravte informace o atributu a dokončete aktualizaci.',
  comment_attribute_name: 'Název atributu příchuti',
  comment_select_category: 'Výběr kategorie příchutě',
  packages_edit_page_description:
    'Upravte informace o balení a dokončete aktualizaci.',
  package_successfully_created: 'Balení bylo úspěšně vytvořeno!',
  package_successfully_created_desc: 'Podívejte se na něj v baleních níže.',
  package_successfully_updated: 'Balení bylo úspěšně aktualizováno!',
  package_successfully_updated_desc: 'Podívejte se na něj v baleních níže.',
  packages_new_page_description:
    'Vyplňte informace o balení a dokončete vytvoření.',
  package_name: 'Název balení',
  content_already_exists: 'Obsah již existuje.',
  language_english: 'Angličtina',
  language_chinese: 'Čínština',
  language_portuguese: 'Portugalština',
  language_spanish: 'Španělština',
  language_dutch: 'Holandština',
  language_french: 'Francouzština',
  language_german: 'Němčina',
  language_russian: 'Ruština',
  language_ukrainian: 'Ukrajinština',
  language_korean: 'Korejština',
  language_italian: 'Italština',
  package_has_no_english_name:
    'Pozor: název balení musí být povinně v angličtině',
  package_volumes: 'Objemy',
  package_new_volume: 'Nový objem',
  package_remove_volume: 'Odebrat objem',
  degree_list_degrees: 'Intenzity',
  degree_edit_degree: 'Upravit intenzitu',
  degree_new_degree: 'Nová intenzita',
  degree_remove_degree: 'Odstranění intenzity',
  category_list_categories: 'Kategorie',
  category_edit_category: 'Upravit kategorii příchutí',
  category_new_category: 'Nová kategorie příchutí',
  category_remove_category: 'Odstranění kategorie příchutí',
  comment_list_comments: 'Atributy',
  comment_edit_comment: 'Upravit atribut příchuti',
  comment_new_comment: 'Nový atribut příchuti',
  comment_remove_comment: 'Odstranění atributu příchuti',
  comment_cancel_new_title: 'Zrušit nový atribut příchuti?',
  comment_cancel_edit_title: 'Zrušit úpravu atributu příchuti?',
  comment_cancel_new_confirm: 'Zrušit nový atribut příchuti',
  comment_cancel_edit_confirm: 'Zrušit úpravu atributu příchuti',
  comment_successfully_created: 'Atribut příchuti byl úspěšně vytvořen!',
  comment_successfully_created_desc: 'Podívejte se na něj v atributu níže.',
  comment_successfully_updated: 'Atribut příchuti byl úspěšně aktualizován!',
  comment_successfully_updated_desc: 'Podívejte se na něj v atributu níže.',
  comment_create_failed: 'Atribut příchuti se nepodařilo vytvořit.',
  comment_update_failed: 'Atribut příchuti se nepodařilo aktualizovat.',
  comment_failed_desc: 'Zkuste to prosím za chvíli znovu.',
  comment_delete_title: 'Smazat atribut?',
  comment_delete_description:
    'Atribut {{name}} bude trvale odstraněn. Opravdu chcete pokračovat?',
  comment_delete_success: 'Atribut byl úspěšně smazán!',
  comment_delete_success_desc: 'Podívejte se na něj v atributu níže.',
  comment_delete_failed: 'Atribut se nepodařilo smazat.',
  comment_delete_failed_desc: 'Zkuste to prosím za chvíli znovu.',
  user_list_users: 'Uživatelé',
  user_edit_user: 'Upravit uživatele',
  user_new_user: 'Nový dodavatel ABI',
  user_export_users: 'Export uživatelů',
  user_list_profiles: 'Profily',
  user_profile_name: 'Název profilu',
  user_profile_select: 'Vybrat profil',
  user_profile_remove: 'Odebrat profil',
  user_profile_save: 'Uložit profil',
  user_remove_user: 'Odebrat uživatele',
  user_use_terms: 'Přijaté podmínky používání',
  report_list_report: 'Zprávy',
  report_start_date: 'Datum zahájení',
  report_end_date: 'Datum ukončení',
  common_privileges: 'Oprávnění',
  common_abi_name: 'ABI jméno',
  common_id: 'ID',
  common_ranked: 'Pořadí',
  common_week: 'Týden',
  common_weeks: 'Týdny',
  common_days: 'Dny',
  common_category: 'Kategorie příchutí',
  common_category_sample: 'Kategorie',
  common_degree: 'Intenzita',
  common_comment: 'Atribut příchuti',
  common_status: 'Status',
  common_zone: 'Zóna',
  common_bu: 'BU',
  common_country: 'Země',
  common_site: 'Místo',
  common_start_date: 'Datum zahájení',
  common_finish_date: 'Datum ukončení',
  common_round_type: 'Typ testu',
  common_type: 'Typ',
  common_round: 'Kolo',
  common_round_id: 'ID kola',
  common_tasters: 'Degustátoři',
  common_taster: 'Degustátor',
  common_sample_performance: 'Ukázkový výkon',
  common_taste: 'Chuť',
  common_key_taster: 'Klíčový degustátor',
  common_sample: 'Vzorek',
  common_samples: 'Vzorky',
  common_sample_type: 'Typ vzorku',
  common_family: 'Styl',
  common_brand: 'Značka',
  common_product_type: 'Typ výrobku',
  common_temperature: 'Podmínky skladování',
  common_storage_times: 'Doba skladování',
  common_sku: 'SKU',
  common_batch: 'ID kód',
  common_kpi_month: 'KPI Měsíc',
  common_logo: 'Logo',
  common_name: 'Název',
  common_notes: 'Poznámky',
  common_email: 'E-mail',
  common_language: 'Jazyk',
  common_terms_of_use: 'Podmínky použití',
  common_new: 'Nový',
  common_profile: 'Profil',
  common_filter: 'Filtrování uživatelů',
  common_download: 'Stáhnout',
  download: 'Stáhnout',
  common_save: 'Uložit',
  common_cancel: 'Zrušit',
  cancel_add_taster_title: 'Zrušit přidání degustátora?',
  cancel_add_taster_description:
    'Degustátoři již byli vybráni. Zrušením výběr zahodíte. Opravdu chcete pokračovat?',
  cancel_add_taster_confirm: 'Zrušit přidání degustátora',
  cancel_enter_concentration_title: 'Zrušit zadání koncentrace?',
  cancel_enter_concentration_description:
    'Zadali jste hodnotu koncentrace. Zrušením zahodíte neuložený údaj. Opravdu chcete pokračovat?',
  cancel_enter_concentration_confirm: 'Zrušit zadání koncentrace',
  cancel_new_package_title: 'Zrušit nové balení?',
  cancel_edit_package_title: 'Zrušit úpravu balení?',
  cancel_new_package_confirm: 'Zrušit nové balení',
  cancel_edit_package_confirm: 'Zrušit úpravu balení',
  common_search_users: 'Vyhledávání uživatelů',
  common_search_group: 'Vyhledávání skupiny',
  common_search_taster: 'Vyhledávání degustátora',
  common_no_data: 'Nezobrazují se žádná data',
  common_edit: 'Upravit',
  no_results_found_for_applied_filters:
    'Nebyly nalezeny žádné výsledky pro použité filtry',
  common_loading: 'Načítání...',
  common_search: 'Hledat...',
  type_more_characters: 'Zadejte ještě {{count}} znak(ů)...',
  common_cannot_be_empty: '{{field}} nemůže být prázdné',
  common_select_option: 'Vyberte možnost...',
  search_placeholder: 'Hledat...',
  no_search_results: 'Žádné výsledky',
  clear_selection: 'Vymazat výběr',
  common_per_page: 'Řádky na stránku',
  common_attributes: 'Atributy',
  common_not_started: 'Nezahájeno',
  common_in_progress: 'Probíhá',
  common_finished: 'Dokončeno',
  common_start: 'Spustit',
  common_detail: 'Zobrazit podrobnosti',
  common_delete: 'Smazat',
  common_position: 'Pozice',
  common_average_key_score: 'Průměrné key skóre',
  common_score: 'Skóre',
  common_score_scale: 'Stupnice skóre',
  common_intensity: 'Intenzita',
  common_report_not_have_data: 'Vybraná kola neměla žádný hlas',
  month_0: 'Leden',
  month_1: 'Únor',
  month_2: 'Březen',
  month_3: 'Duben',
  month_4: 'Květen',
  month_5: 'Červen',
  month_6: 'Červenec',
  month_7: 'Srpen',
  month_8: 'Září',
  month_9: 'Říjen',
  month_10: 'Listopad',
  month_11: 'Prosinec',
  dropdown_change_picture: 'Změnit obrázek',
  dropdown_language: 'Jazyk',
  dropdown_logout: 'Odhlášení',
  logout_title: 'Odhlášení, prosím čekejte…',
  round_not_started: 'Nezahájeno',
  round_in_progress: 'Probíhá',
  round_finished: 'Dokončeno',
  round_filter_start: 'Spustit',
  tasting_list_rounds: 'Seznam kol',
  menu_tasting_session: 'Degustace',
  menu_panel_management: 'Správa panelu',
  menu_process_management: 'Správa procesu',
  menu_product_management: 'Správa produktů',
  menu_attributes_management: 'Správa atributů',
  tasting_finish_sample: 'Finální vzorek',
  tasting_comments: 'Komentáře',
  tasting_beer_profile: 'Profil piva',
  tasting_need_select_score_comments:
    'Pro pokračování musíte nastavit skóre a přidat alespoň jeden komentář...',
  tasting_finish_taste: 'Dokončit ochutnávku',
  tasting_finish_tasting: 'Dokončit ochutnávku',
  common_no_comments: 'Žádné komentáře',
  previous_comments: 'Předchozí komentáře',
  review_submit_title:
    'Jste si jisti, že jste připraveni odeslat své výsledky?',
  review_submit_description: 'Později už nebudete moci upravovat',
  review_finish_taste: 'Dokončit ochutnávku',
  review_warning_sample_title: 'Máte neochutnané vzorky!',
  review_warning_sample_description:
    'Přejete si pokračovat bez jejich ochutnání?',
  review_warning_sample_review: 'Revize',
  review_warning_sample_ok: 'Pokračovat',
  review_warning_preference_description:
    'Před pokračováním vyberte preferenci.',
  review_warning_tie_sample_title: 'Máte svázané vzorky!',
  review_warning_tie_sample_description:
    'Nemůžete pokračovat bez jejich hodnocení!',
  review_warning_tie_sample_review: 'Revize',
  common_submit: 'Odeslat',
  common_discussion: 'Diskuse',
  common_not_informed: 'Není informován',
  discussion_order_number: 'Pořadí podle pozice',
  discussion_order_brewery: 'Pořadí podle pivovaru',
  discussion_order_ranking: 'Seřadit podle pořadí',
  discussion_order_brand: 'Pořadí podle značky',
  discussion_order_score: 'Pořadí podle skóre',
  discussion_order_key_score: 'Pořadí podle key skóre',
  discussion_order_overall_rank: 'Pořadí podle celkového pořadí',
  discussion_order_key_rank: 'Pořadí podle key pořadí',
  discussion_export_error: 'Soubor se nepodařilo uložit!',
  discussion_ranking: 'Pořadí',
  discussion_overall_ranking: 'Celkové pořadí',
  discussion_key_ranking: 'Key pořadí',
  common_brewery: 'Pivovar',
  common_trial_identifier: 'ID Testu',
  common_key_score: 'Key skóre',
  round_report: 'Export do Excelu',
  common_comments: 'Komentáře',
  message_you_cannot_delete_all_comments:
    'Při úpravě hlasování nemůžete smazat všechny komentáře',
  common_message_empty_profile: 'Název profilu není povolen prázdný',
  common_message_out_score_range: 'skóre mimo rozsah',
  tasting_need_select_score: 'Nejprve musíte nastavit skóre!',
  common_category_name: 'Kategorie',
  categories_new_category: 'Nová kategorie',
  categories_remove_category: 'Opravdu chcete odstranit kategorii',
  categories_list_categories: 'Kategorie',
  categories_list_all_categories: 'Všechny kategorie',
  common_category_sample_name: 'Vzorek',
  categories_new_category_sample: 'Nový vzorek',
  categories_remove_category_sample: 'Opravdu chcete odstranit vzorek',
  categories_list_categories_samples: 'Vzorky',
  tasting_help: 'Nápověda k degustaci',
  common_back: 'Zpět',
  common_next: 'Další',
  common_sample_id: 'ID vzorku',
  common_sample_date: 'Datum vzorku',
  common_duplicate: 'Duplikovat',
  tasting_raw_materials: 'Suroviny',
  tasting_example_sensory_risk:
    'Příklad hlavního senzorického rizika: neshoda s očekávanou chutí',
  tasting_procedure: 'Proces',
  tasting_sample_preparation: 'Příprava vzorku',
  tasting_help_comments: 'Poznámky',
  common_collection_point: 'Místo odběru',
  common_collection_date: 'Datum odběru',
  common_brew_number: 'Čísla várek/číslo MES',
  common_need_explain_nok: 'Nelze mít vzorky NOK bez komentáře!',
  common_percent_ok: 'Procento OK',
  common_show_all: 'Zobrazit vše',
  common_import: 'Import',
  common_download_template: 'Stáhnout šablonu',
  sample_import_message: 'xlsx',
  common_template: 'Šablona',
  common_yes: 'Ano',
  common_no: 'Ne',
  common_only_kpi_sample: 'Pouze KPI vzorek',
  common_need_volte_first: 'Vzory nelze komentovat bez předchozího hlasování!',
  common_name_template: 'Název šablony',
  interaction_log: 'Záznam o interakci',
  common_message_zone_empty: 'Zóna nesmí být prázdná',
  common_message_country_empty: 'Země nesmí být  prázdná',
  common_message_site_empty: 'Místo nesmí být prázdné',
  user_new_profile_save: 'Vytvořen nový profil',
  common_in_privileges: 'v oprávněních',
  common_download_files: 'Stáhnout soubory',
  common_create_action: 'Vytvořit akci',
  common_action_list: 'Seznam akcí',
  common_create_action_description:
    'Vyplňte podrobnosti akce pro tento vzorek.',
  common_optional: 'volitelné',
  action_deadline: 'Termín',
  action_description: 'Popis akce',
  action_description_autofill_tooltip: 'Popis akce',
  action_description_autofill_tooltip_description:
    'Automaticky vygenerováno (ID kola / Pivovar / Název vzorku / Datum výroby / Vytvářející uživatel) + dodatečný popis',
  action_owner: 'Odpovědná osoba',
  action_meeting: 'Schůzka záznamu o interakci',
  action_meeting_list: 'IAL schůzka',
  action_producing_site: 'Místo výroby',
  action_production_date: 'Datum výroby',
  action_closed_time: 'Čas uzavření',
  action_meeting_placeholder: 'Vyberte schůzku',
  action_status: 'Stav',
  action_status_draft: 'Koncept',
  action_status_not_started: 'Nezahájeno',
  action_status_in_progress: 'Probíhá',
  action_status_delayed: 'Zpožděno',
  action_status_close: 'Zavřít',

  action_menu_close: 'Zavřít',
  common_view_details: 'Zobrazit detaily',
  action_cancel: 'Zrušit',
  action_add_comment: 'Přidat komentář',
  action_status_canceled: 'Zrušeno',
  status_record: 'Záznam stavu',
  no_status_record: 'Žádné záznamy o stavu',
  action_type: 'Typ akce',
  action_create_user: 'Vytvořil uživatel',
  action_create_time: 'Čas vytvoření',
  action_creator: 'Tvůrce',
  action_root_cause: 'Hlavní příčina',
  action_description_placeholder: 'Zadejte popis akce...',
  action_root_cause_placeholder: 'Zadejte hlavní příčinu...',
  action_comment_added: 'Komentář úspěšně přidán',
  action_comment_add_failed: 'Nepodařilo se přidat komentář',
  action_comment_placeholder: 'Zadejte svůj komentář...',
  action_status_changed_with_comment: 'Stav změněn s komentářem',
  required_comment_banner:
    'Protože nejste vlastníkem této akce, je nutné poskytnout komentář jménem vlastníka.',
  cancel_and_comment: 'Zrušit a okomentovat',
  close_and_comment: 'Zavřít a okomentovat',
  action_edit_action: 'Upravit akci',
  action_owner_placeholder: 'Vyberte odpovědnou osobu',
  action_created_successfully: 'Akce byla úspěšně vytvořena!',
  action_created_successfully_desc:
    'Podívejte se na vytvořenou akci v seznamu akcí.',
  action_updated_successfully: 'Akce byla úspěšně aktualizována!',
  action_updated_successfully_desc:
    'Podívejte se na aktualizovanou akci v seznamu akcí.',
  action_create_failed: 'Při vytváření akce došlo k problému',
  action_update_failed: 'Při aktualizaci akce došlo k problému',
  action_save_failed_desc: 'Zkuste to prosím za chvíli znovu.',
  action_deleted_successfully: 'Akce byla úspěšně smazána!',
  action_deleted_successfully_desc: 'Podívejte se do seznamu akcí.',
  action_delete_failed: 'Při mazání akce došlo k problému',
  delete_action_confirm_title: 'Smazat akci?',
  delete_action_confirm_description:
    'Tato akce bude trvale odstraněna. Opravdu chcete pokračovat?',
  action_added_notification: '[{{userName}}] přidal novou akci',
  action_updated_notification: '[{{userName}}] aktualizoval svou akci',
  action_deleted_notification: '[{{userName}}] smazal svou vlastní akci',
  view_action_list: 'Zobrazit seznam akcí',
  pdf_viewer: 'Prohlížeč PDF',
  common_all: 'Všechny',
  common_continue: 'Pokračovat',
  common_minimum_score: 'Min',
  common_maximum_score: 'Max',
  common_average_score: 'Průměrná hodnota',
  file_upload_fail:
    'Nepodařilo se nahrát soubor, došlo k následujícím chybám: ',
  file_upload_success_with_error:
    'Nahrávání proběhlo úspěšně s výjimkou následujících chyb: ',
  missing_fields: 'chybějící pole',
  column_error: 'chyba sloupce',
  common_line: 'Řádek',
  file_no_samples: 'V souboru nebyly nalezeny žádné vzorky!',
  file_success_upload: 'Úspěšné nahrání souboru!',
  file_duplicated_kpi_project: 'Duplikovaný KPI nebo projekt',
  round_schedule_maximum_length: 'Maximální délka názvu kola je 40 znaků.',
  sample_malt_varieties: 'Odrůda sladu',
  error_sample_already_in_round: 'Vzorek se již v kole nachází',
  malt_varieties_has_no_english_name:
    'Musíte mít alespoň jeden název sladové odrůdy.',
  malt_varieties_duplicate: 'Upozornění: Existuje odrůda sladu s tímto názvem',
  malt_varieties_remove: 'Odstranit odrůdu',
  malt_varieties_new: 'Nová odrůda',
  malt_varieties_edit: 'Upravit odrůdu',
  malt_varieties_enter_name: 'Zadejte název',
  malt_varieties_page_description:
    'Spravujte všechny odrůdy sladu a jejich konfigurace na jednom místě.',
  malt_varieties_save_success: 'Odrůda sladu byla úspěšně vytvořena!',
  malt_varieties_save_success_desc: 'Zkontrolujte to v odrůdách sladu níže.',
  malt_varieties_update_success: 'Odrůda sladu byla úspěšně aktualizována!',
  malt_varieties_update_success_desc: 'Zkontrolujte to v odrůdách sladu níže.',
  malt_varieties_delete_title: 'Odstranit odrůdu sladu?',
  malt_varieties_delete_description:
    'Odrůda sladu {{name}} bude trvale odstraněna. Opravdu chcete pokračovat?',
  malt_varieties_delete_success: 'Odrůda sladu byla úspěšně odstraněna!',
  malt_varieties_delete_success_desc: 'Zkontrolujte to v odrůdách sladu níže.',
  malt_varieties_delete_failed: 'Odstranění odrůdy sladu se nezdařilo.',
  malt_varieties_delete_failed_desc: 'Zkuste to prosím za chvíli znovu.',
  cancel_new_malt_variety_title: 'Zrušit novou odrůdu sladu?',
  cancel_edit_malt_variety_title: 'Zrušit úpravu odrůdy sladu?',
  cancel_new_malt_variety_confirm: 'Zrušit novou odrůdu sladu',
  cancel_edit_malt_variety_confirm: 'Zrušit úpravu odrůdy sladu',
  reports_no_dates: 'Datum zahájení a datum ukončení jsou povinné!',
  reports_date_range_message: 'Rozsah dat nesmí být větší než 1 rok!',
  round_save_select_site: 'Pro uložení kola je nutné vybrat lokalitu',
  common_error: 'Ups! Něco se pokazilo, zkuste to prosím znovu',
  common_horizontal: 'Horizontální rozložení',
  common_unit: 'Jednotka',
  common_supplier: 'Dodavatel',
  common_flavor: 'Příchuť',
  concentration_of_the_base_beer: 'Koncentrace základního piva',
  threshold_aml_method: 'Metoda AML (vzestupná metoda limitů)',
  threshold_component_concentration: 'Koncentrace složky',
  threshold_sample_different_help: 'Který vzorek se liší?',
  threshold_each_set_random_order: 'V každé sadě v náhodném pořadí.',
  threshold_select_base_beer: 'Vyberte základní pivo',
  common_unity: 'Jednota',
  common_finish_session: 'Dokončit ochutnávku',
  common_filters: 'Filtry',
  review_submit_threshold: 'Jste si jisti, že chcete uložit?',
  threshold_coder_wrong: 'Zadaný kód je špatný. Zadejte prosím opravený kód.',
  threshold_didnt_enter_the_code: 'Zadejte prosím svůj kód',
  code: 'Kód',
  common_batch_code: 'Kód šarže',
  threshold_samples_required: 'Základní pivo a Příchuť jsou povinné',
  threshold_information_helper_sample:
    'Chcete-li uložit informace o prahovém vzorku, klikněte na tlačítko Uložit, aby se změny zachovaly',
  code_digits: 'Zadejte třímístný kód, který vám byl přidělen',
  threshold_sample_spiked_with:
    'V každé sadě vyberte vzorek, do kterého bylo něco přidáno (spiked sample) ',
  threshold_code_already_tasted:
    'Tento kód již ochutnal jiný uživatel. Zadejte jiný kód.',
  common_kpi_brands: 'KPI značky',
  common_year: 'Rok',
  common_new_kpi_brand: 'Nová KPI značka',
  common_action: 'Akce',
  kpi_brand_details_title: 'Detaily KPI značky',
  kpi_brand_details_description:
    'Zobrazení kompletních informací a stavu procesu schvalování.',
  approval_action: 'Schvalovací akce',
  select_approval_action: 'Vyberte schvalovací akci',
  reject_reason_title: 'Důvod zamítnutí',
  reject_reason_description: 'Uveďte prosím důvod zamítnutí.',
  reject_reason_label: 'Důvod zamítnutí',
  reject_reason_placeholder: 'Zadejte důvod zamítnutí...',
  reject_reason_placeholder_site:
    "Zadejte důvod zamítnutí pro tento web '{{site}}'...",
  common_confirm: 'Potvrdit',
  common_success: 'Úspěch',
  common_save_failed: 'Uložení se nezdařilo. Zkuste to znovu.',
  approval_status_saved_success: 'Stav schválení byl úspěšně uložen!',
  common_comment_by_category: 'Komentáře podle kategorie',
  common_alphabetic_comment: 'Abecední komentáře',
  common_name_pts_code: 'Kód PTS',
  common_name_pts_code_placeholder: 'Kód',
  common_name_process_item: 'Zpracovávaná položka',
  common_name_process_item_placeholder: 'Položka',
  common_global_brands: 'Globální značky',
  common_global_brand: 'Globální značka',
  common_target_global_brand: 'Cíl pro globální značku',
  common_focus_brand: 'Vybraná značka',
  common_target_focus_brand: 'Cílová hodnota pro vybranou značku',
  common_strategic_brand: 'Strategická značka',
  common_target_strategic_brand: 'Cíl pro strategickou značku',
  common_maximun_sites: 'Nejvyšší počet k porovnání je',
  common_state_reason_rejecting: 'Uveďte důvod proč to oddělení odmítlo',
  common_rejected_note: 'Odmítnutá poznámka',
  report_list_report_kpi: 'Zprávy KPI',
  report_list_report_taste: 'Degustační zprávy',
  select_brand_to_filter: 'Vyberte globální značku!',
  select_year_to_filter: 'Vyberte rok!',
  kpi_only_numbers_warning: 'Akceptujte pouze čísla na cílových hodnotách',
  kpi_max_number_range_warning: 'Vaše cílová značka musí být v rozmezí 1 až 9',
  kpi_already_selected_brand_warning:
    'Tuto značku máte vybranou, vyberte prosím jinou značku',
  kpi_no_kpi_informed_warning:
    'Nebyla zadána žádná hodnota KPI. Doplňte prosím tuto hodnotu.',
  kpi_select_year_warning: 'Vyberte rok',
  kpi_select_site_warning: 'Vyberte lokalitu',
  kpi_existing_configuration_warning:
    'Máte hodnoty kpi ze stejného místa a roku.',
  kpi_target_empty_warning: 'Cíl jedné z vašich značek je prázdný',
  kpi_saved_successfully: 'Vaše hodnoty byly úspěšně uloženy!',
  kpi_submitted_successfully: 'Vaše hodnoty byly úspěšně odeslány!',
  kpi_max_decimals_warning:
    'Vaše cílová hodnota musí být uvedena s přesností na 3 desetinná místa',
  kpi_count_as_kpi_sample: 'Počítejte jako KPI',
  samples_uncheck_kpi_sample_tooltip:
    'Zrušte zaškrtnutí tohoto políčka, pokud nechcete, aby se tento vzorek započítával do KPI',
  reports_mandatory_zone_filter: 'Vyberte alespoň jednu zónu',
  common_approve_reject: 'Schválit/odmítnout',
  common_approve: 'Schválit',
  submission_type: 'Typ podání',
  custom_scale_title: 'Vlastní měřítko',
  custom_scale_grid_header_score: 'Skóre',
  custom_scale_grid_header_ageind_scale: 'Stupnice nuceného stárnutí',
  the_value_cannot_be_null: 'Hodnota nesmí být nulová!',
  unique_id: 'Jedinečné ID',
  report_filter_rounds_description:
    'Pro načtení možností kol je nutné vybrat povinná pole.',
  reports_mandatory_test_type: 'Vyberte typ testu.',
  round_reports_month_warning:
    'Období mezi datem zahájení a datem ukončení musí být maximálně 6 měsíců.',
  zone_can_not_empty: 'Oblast nesmí být prázdná!',
  error_loading_data:
    'Chyba při načítání dat: Zkontrolujte připojení a znovu načtěte data.',
  beer_batch: 'Šarže piva',
  list_of_beers: 'Seznam piv',
  random: 'Náhodné',
  preview: 'Náhled místa',
  select_the_flavor: 'Výběr příchutě',
  flavor_threshold: 'Práh příchutě',
  input_digital_number: 'Zadejte digitální číslo...',
  concentration: 'Koncentrace',
  flavor_order: 'Pořadí příchutí:',
  last: 'Poslední',
  tasting: 'Degustace',
  tasting_page_description:
    'Prováděte hodnocení ochutnávky vzorku a diskutujte o výsledku.',
  confirmation: 'Potvrzení',
  do_you_confirm_the_evaluation_of_this_sample:
    'Potvrzujete hodnocení tohoto vzorku?',
  confirm: 'Potvrzuji',
  evaluate: 'Hodnotit',
  correct_answer: 'Správná odpověď',
  threshold: 'Prahová hodnota',
  let_a_comment_about_the_tasting: 'Napiště komentář k degustaci',
  send: 'Odeslat',
  right_now: 'Právě teď',
  minute_ago: 'před m',
  hour_ago: 'před h',
  day_before: 'před d',
  year_ago: 'před rokem',
  add_a_flavor: 'Přidat příchuť',
  soft_drinks: 'Nealkoholické nápoje',
  soft_drinks_brand: 'Značka nealkoholických nápojů',
  soft_drinks_brand_target: 'Cílová hodnota pro značka nealkoholických nápojů ',
  column_options: 'Možnosti sloupců',
  configure_table_title: 'Přizpůsobit sloupce',
  configure_table: 'Konfigurovat tabulku',
  configure_table_description:
    'Vyberte viditelné sloupce a upravte jejich pořadí.',
  configure_table_helper:
    'Musí být viditelné alespoň 2 sloupce a maximálně 4 pevné sloupce.',
  configure_table_fixed_left: 'Pevně vlevo',
  configure_table_scroll_area: 'Oblast posouvání',
  configure_table_fixed_right: 'Pevně vpravo',
  configure_table_empty_left:
    'Přetáhněte sem sloupec a pevně jej umístěte vlevo',
  configure_table_empty_right:
    'Přetáhněte sem sloupec a pevně jej umístěte vpravo',
  configure_table_save: 'Uložit změny',
  configure_table_reset: 'Obnovit výchozí',
  configure_table_discard: 'Zahodit změny',
  configure_table_show: 'Zobrazit',
  configure_table_hide: 'Skrýt',
  configure_table_min_visible: 'Musí zůstat viditelné alespoň 2 sloupce',
  configure_table_max_fixed: 'Můžete pevně umístit maximálně 4 sloupce',
  configure_table_drag: 'Přetažením změnit pořadí',
  configure_table_dragging: 'Přetahování',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Vyberte, které sloupce chcete zobrazit.',
  countdown: 'Odpočítávání',
  less_than_five_minutes:
    'Tato degustace skončí za 5 minut, pokud potřebujete pokračovat, kontaktujte správce, aby posunul datum ukončení.',
  the_countdown_to_the_evaluation_has_ended:
    'Nelze vstoupit, protože odpočítávání této degustační relace skončilo',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Odpočítávání, kolik času máte na dokončení ochutnávky vzorků',
  only_six_flavors_can_be_added_at_most: 'Lze přidat maximálně 6 příchutí!',
  concentration_of_the_flavor: 'Koncentrace příchutě',
  input_value: 'Zadejte prosím',
  Concentration_of_the_flavor_is_required: 'Koncentrace příchutě je vyžadována',
  previous_round: 'Předchozí kolo',
  next_round: 'Další kolo',
  the_end_time_is_greater_than_the_current_time:
    'Čas ukončení musí být větší než aktuální čas, pokud vyberete stejný den jako aktuální den, vyberte nejprve hodinu a minutu!',
  check_the_answer_at_the_end_of_the_countdown:
    'Pro kontrolu výsledku vyčkejte, až odpočítávání klesne na nulu.',
  incremental_step: 'Navýšení',
  set3_concentration: 'Koncentrace Sady 3',
  concentration_increments_between_levels:
    'Přírůstky koncentrace mezi jednotlivými úrovněmi',
  incremental_set3_concentration_required:
    'Je požadováno "Navýšení" a Set3 Concentration.',
  sprint: 'Sprintu',
  sprint_number_greater_than_zero: 'Číslo sprintu musí být větší než 0',
  sprint_notes_at_least_one_note:
    'Poznámky ke sprintu musí mít alespoň jednu poznámku',
  sprint_patch_notes_success_update:
    'Poznámky k opravám sprintu byly úspěšně aktualizovány.',
  sprint_patch_notes_error_update: 'Poznámky nebylo možné uložit.',
  sprint_number: 'Číslo sprintu',
  sprint_patch_notes: 'Poznámky k opravám Sprintu',
  note: 'Poznámka',
  select_all: 'Vybrat vše',
  please_add_samples_first: 'Nejprve přidejte vzorky',
  reverse: 'Obrátit',
  score_scale: 'Stupnice Ab InBev',
  description: 'Popis',
  aditional_criteria: 'Dodatečná kritéria',
  new_test: 'Nový test',
  triangle_test: 'Trojúhelníkový test',
  triangle_test_name: 'Název trojúhelníkového testu',
  you_can_not_set_three_identical_samples: 'Nelze nastavit 3 identické vzorky',
  its_mandatory_to_input_test_name: 'Je povinné zadat Název testu.',
  its_mandatory_to_input_sample_information:
    'Je povinné zadat informace o vzorku.',
  attention: 'Pozor',
  test_number: 'Číslo testu',
  you_selected_the: 'Vybrali jste',
  next_sample: 'Další vzorek',
  remove_triangle_test: 'Odstranit trojúhelníkový test',
  test: 'Test',
  confirm_remove: 'Potvrzujete odstranění tohoto testu?',
  you_can_only_select_up_to_five: 'Můžete vybrat pouze 5 druhů.',
  reports_mandatory_zone_country_site_filter:
    'Zóna, země, lokalita jsou povinné!',
  reports_mandatory_brand_filter: 'Vyberte alespoň jednu značku',
  download_label: 'Stáhnout štítek',
  reports_by_producing_site: 'Přehledy podle místa produkce',
  standard: 'Standardní',
  input_test: 'Vstupní test',
  detecting: 'Detekce···',
  connected: 'Připojeno',
  current_taster: 'Aktuální degustátor',
  alcohol_concentration: 'Koncentrace alkoholu',
  alcohol_result_submit_failed_title: 'Při odesílání výsledku došlo k problému',
  alcohol_result_submit_failed_desc: 'Zkuste to prosím za chvíli znovu.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    'Výsledek testu na alkohol překračuje normu. Zopakujte prosím test později!',
  alcohol_test_qualified: 'Kvalifikovaný test na alkohol',
  alcohol_concentration_configuration: 'Konfigurace koncentrace alkoholu',
  breathalyzer_configuration_description:
    'Nakonfigurujte koncentraci alkoholu pro každý závod a stav řízení uživatelů.',
  breathalyzer_configuration_save_success_title: 'Konfigurace alkoholtesteru byla úspěšně aktualizována!',
  breathalyzer_configuration_save_success_description: 'Aktualizované konfigurace naleznete v nastavení níže.',
  breathalyzer_configuration_save_failed_title: 'Při aktualizaci konfigurace alkoholtesteru došlo k problému',
  breathalyzer_configuration_save_failed_description: 'Zkuste to prosím za chvíli znovu.',
  cancel_configuration_title: 'Zrušit konfiguraci?',
  cancel_configuration_description: 'Provedli jste změny konfigurace. Zrušením zahodíte neuložené změny. Opravdu chcete pokračovat?',
  cancel_configuration_confirm: 'Zrušit konfiguraci',
  driving_configuration: 'Konfigurace řízení',
  configuration: 'Konfigurace',
  input_result: 'Zadání výsledku',
  maximum_alcohol_concentration: 'Překročení koncentrace alkoholu',
  breathalyzer: 'Dechová zkouška',
  breathalyzer_page_description:
    'Spravujte všechny výsledky dechové zkoušky a jejich konfigurační standardy na jednom místě.',
  please_input_a_positive_number_up_to_n_decimal_places:
    'Zadejte kladné číslo s přesností na {{field}} desetinných míst.',
  you_must_input: 'Musíte zadat',
  driving: 'Řízení',
  test_time: 'Čas testu',
  input_type: 'Zadejte typ',
  list_breathalyzer: 'Alkohol tester',
  Manual: 'Manuální',
  auto: 'Automaticky',
  Breathalyzer: 'Alkohol tester',
  you_do_not_have_privilege_to_export_this_report:
    'Nemáte oprávnění exportovat tuto zprávu',
  competitor_beer: 'Konkurenční pivo',
  split_round: 'Rozdělené kolo',
  reset: 'Resetovat',
  how_many_rounds_splitting_do_you_want_to_make: 'Kolik chcete rozdělit kol',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'Nelze rozdělit kolo, které již bylo rozděleno nebo které právě probíhá',
  hide_sample_details: 'Skrýt podrobnosti o vzorku',
  hide_sample_details_auto_hide:
    'YES - vzorky můžete rozdělit a automaticky zobrazit všechny skryté informace po ochutnání všech rozdělených kol.',
  hide_sample_details_manual_hide:
    'Manual - vzorky nelze rozdělit a je třeba přidělit dočasného správce, aby ručně přepnul skrývání nebo skrývání na stránce diskuze.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    'Údaje budou degustátorům skryty: Pivovar, datum výroby, značka, odrůda sladu a ID vzorku',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    'V tomto kole je vybrána možnost Ruční, funkce rozdělení není k dispozici, pro rozdělení můžete zvolit možnost Automatické skrytí nebo Žádné skrytí.',
  data_will_be_hidden_for_ok_nok:
    'Všechny relevantní údaje budou degustátorům skryty',
  you_can_not_add_duplicate_attributes: 'Nelze přidávat duplicitní atributy.',
  menu: 'MENU',
  link_breathalyzer: 'Připojeno',
  not_link_breathalyzer: 'Nepřipojeno',
  breathalyzer_to_link: 'Připojit Alkohol tester',
  breathalyzer_connection_failed_title:
    'Připojení alkohol testeru se nezdařilo',
  breathalyzer_connection_failed_desc: 'Obnovte stránku a zkuste to znovu.',
  breathalyzer_can_not_to_link_for_this_browser:
    'Funkce Alkohol testeru je vyvinuta tak, aby fungovala v prohlížeči Google Chrome a používala zařízení PC.',
  reopen: 'Znovu otevřít',
  round_reopen_message: 'Jste si jisti, že chcete znovu otevřít Round',
  common_production_line: 'Výrobní linka',
  common_packaged_beer_data_code: 'Datový kód baleného piva',
  common_masking_process_for_bottles: 'Proces maskování lahví',
  common_str_number_days_over_aged: 'Počet dní staření',
  common_over_aged_beer: 'Přezrálé pivo',
  sample_successfully_swapped: 'Vzorek byl úspěšně vyměněn.',
  scoring: 'Bodování',
  configure_available_flavors: 'Konfigurace dostupných příchutí',
  process_check: 'Kontrola procesu',
  new_process_check: 'Kontrola nového procesu',
  edit_process_check: 'Upravit kontrolu procesu',
  remove_process_check: 'Odstranění kontroly procesu',
  common_package: 'Balení',
  common_department: 'Oddělení',
  common_shift: 'Směna',
  common_tank: 'Tank',
  common_oknok: 'OKNOK',
  common_remark: 'Poznámka',
  show_all_process_check: 'Zobrazit všechny kontroly procesů',
  show_all_process_check_help_circle:
    'Zobrazení kontroly procesu vytvořené za šest měsíců ode dneška. Zaškrtněte toto políčko, pokud chcete zobrazit také kontrolu procesu vytvořenou během jednoho roku ode dneška',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    'Datum vzorku nesmí být větší než aktuální čas!',
  common_job_position: 'Pracovní pozice',
  decimal_sep: 'Desetinná čárka',
  is_swapped_to: 'Vyměnit za',
  review_warning_comment_title: 'Máte neokomentované vzorky!',
  continuous_typing: 'Průběžné zadávání',
  continuous_typing_tips:
    'Pokračujte v psaní „Atribut“ po výběru/zadání „Intenzity“.',
  BSSI_Reports: 'Reporty BSSI',
  data_analysis_sip: 'Analýza dat - SIP',
  select_the_color: 'Vyberte barvu',
  color: 'Barva',
  download_document: 'Stáhnout dokumenty',
  Month_of_Discontinued_Production: 'Měsíc přerušené výroby',
  Suspension_List: 'Seznam pozastavení',
  New_Suspension: 'Nové pozastavení',
  new_suspension_page: 'Nové pozastavení',
  edit_suspension_page: 'Upravit pozastavení',
  Brand_name: 'Název značky',
  List_Brewery_Production_Suspension: 'Seznam pozastavení výroby pivovaru',
  Upload_successfully: 'Soubor byl úspěšně nahrán!',
  training_materials: 'Tréninkové materiály',
  Remove_Suspension: 'Odstranit pozastavení: ',
  Add_Absence_Reason: 'Přidat důvod absence',
  Reason: 'Důvod',
  Select_reason: 'Vyberte důvod',
  You_have_duplicate_absence_dates: 'Máte duplicitní data absence',
  Remove_Absence: 'Odebrat absenci: ',
  Absence_Title:
    'Vyberte prosím čas a důvod své nepřítomnosti na degustaci. Záznamy můžete zobrazit nebo odstranit v části Odeslaný důvod.',
  Shipping_Site: 'Místo odeslání',
  shipping_received: 'Přijatá zásilka',
  receive_sample_alert: 'Jste si jisti, že jste vzorek obdrželi?',
  receive_uncheck_alert: 'Jste si jisti, že chcete zrušit zaškrtnutí?',
  all_received: 'Vše přijato',
  not_all_received: 'Ne všechno přijato',
  not_for_shipping: 'Není určeno k odeslání',
  receive_hint: 'Vyberte všechna místa, která obdrží tento vzorek',
  absence_reason: 'Důvod absence',
  Page1: 'Stránka {{field}}',
  Search: 'Vyhledávání',
  page_total: 'Celkem',
  start_date: 'Datum zahájení',
  end_date: 'Datum ukončení',
  ok_for_all: 'OK pro všechny',
  last_days: 'Posledních {{field}} dnů',
  today: 'Dnes',
  its_mandatory_to_select_sample_A_and_sample_B:
    'Je nutné vybrat vzorek A a vzorek B.',
  its_mandatory_to_select_sample_A: 'Je povinné vybrat vzorek A.',
  its_mandatory_to_select_sample_B: 'Je povinné vybrat vzorek B.',
  triangle_comment: 'Komentář',
  select_sample: 'Vyberte vzorek',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Filtr Datum vzorku,posledních 7 dní ve výchozím nastavení , export do Excelu na základě této filtrované doby trvání.',
  select_all_flavor: 'Vybrat vše',
  deselect_all: 'Zrušit výběr všech',
  email_distribution: 'Příjemci měsíčního reportu',
  recipients: 'Komu',
  cc_recipients: 'Kopie',
  new_email_distribution: 'Noví příjemci měsíčního reportu',
  edit_email_distribution: 'Upravit příjemce měsíčního reportu',
  distribution_type: 'Typ distribuce',
  the_score_entered_is_invalid:
    'Zadané skóre je neplatné. Podívejte se prosím na bodovou stupnici a zadejte skóre znovu.',
  service_now:
    'Klepnutím na tlačítko vytvoříte lístek incidentu, abyste nahlásili problém a získali pomoc.',
  service_now_tips:
    'Ahoj, pokud narazíte na nějaký problém nebo chcete požádat o podporu, můžete kliknout sem a nahlásit jej přímo v ServiceNow, náš tým podpory se s vámi co nejdříve spojí.',
  done: 'Hotovo',
  changes_you_made_may_not_be_saved:
    'Provedené změny se nemusí uložit. Chcete pokračovat a přijít o změny?',
  cannel_auto_save_tips:
    'Aktuální výkon degustační stránky je vylepšen, nezapomeňte prosím kliknout na tlačítko Dokončit vzorek pro uložení a odeslání výsledku degustace.',
  list_email_page_tips:
    'Toto je návod, jak nastavit správný vzorek KPI, abyste se ujistili, že měsíční zpráva zóny odráží přesnou analýzu pro vaši zónu MCS degustace',
  list_email_page_helps:
    'Návod, jak nastavit vzorek KPI, aby ukázal přesné údaje v měsíční zprávě Zóny (Zone Monthly Report)',
  kpi_instruction: 'Instrukce pro KPI',
  group_no_recipients_message: 'Je zapotřebí alespoň jeden příjemce.',
  the_current_distribution_type_already_exists:
    'Aktuální typ distribuce již existuje, znovu vyberte typ nebo vraťte seznam.',
  distribution_type_message_empty: 'Typ distribuce není povolen prázdný',
  add_samples: 'Přidejte vzorek(y) do kola',
  copy_this_sample: 'Duplikovat vzorek',
  remove_this_sample: 'Odstranění vzorku',
  drag_samples_here: 'Přetáhněte vzorky sem',
  drop_here: 'Zde upusťte',
  multiple_selection_tips: `Pro stejný typ vzorku můžete vybrat několik vzorků najednou. Vyzkoušejte to kliknutím na ‘+’ a ‘-’.`,
  all_add_once_tips: `Kliknutím na tlačítko ‘Vybrat vše’ automaticky přidáte 1 vzorek ke každému vybranému typu vzorku.`,
  copy_confirm_tip: 'Jste si jisti, že chcete vzorek zkopírovat?',
  user_non_abi_user: 'Nový dočasný uživatel',
  language_of_email_invitation: 'Jazyk e-mailové výzvy',
  add_non_abi_users_to_round:
    'Dočasný uživatel obdrží e-mailovou pozvánku s odkazem na účast na konkrétní degustaci.',
  change_non_abi_users_to_round:
    'Dočasný degustátor, kterého jste pozvali, obdrží e-mailovou pozvánku s odkazem na účast na této degustaci.',
  guest: 'Host',
  email_to_all: 'E-mail všem',
  send_email: 'Odeslání pozvánky e-mailem',
  temporary_non_abi_taster: 'Dočasný degustátor',
  user_type: 'Typ uživatele',
  email_invitation_delivery_request_sent: 'Hromadná pozvánka byla odeslána.',
  incorrect_e_mail_formatting: 'Nesprávné formátování e-mailu',
  all_tasters: 'Všichni degustátoři',
  tasters: 'Degustátoři',
  key_tasters: 'Klíčoví degustátoři',
  non_key_tasters: 'Neklíčoví degustátory',
  taster_already_started_cannot_change: 'Degustátor již začal, nelze změnit',
  temporary: 'Dočasný uživatel',
  maximum_number_of_samples_is: 'Maximální počet vzorků je',
  sample_added: 'Přidané vzorky',
  click_to_view_scale_of_flavour_intensities:
    'Kliknutím na odkaz zobrazíte podrobné stupnice intenzity',
  list_next_week_plan: 'Plánování týdenních relací',
  common_time_zone: 'Časové pásmo',
  common_last_response_time: 'Čas poslední reakce',
  new_week_plan: 'Degustace nového týdne',
  invited_week: 'Týden, kdy jste byli pozváni',
  email_language: 'Jazyk e-mailu',
  save_and_send_email: 'Uložit a odeslat e-mail',
  common_start_time: 'Čas zahájení',
  common_end_time: 'Čas ukončení',
  session_name_email_subject: 'Název relace / Předmět e-mailu',
  location: 'Místo',
  calendar_confirm: 'Potvrzení kalendáře',
  edit_week_plan: 'Upravit týdenní sezení',
  common_session: 'Degustace',
  round_remove_plan: 'Jste si jisti, že chcete plán odstranit',
  email_response: 'E-mailová odpověď',
  are_you_confirming_to_send_the_invitation_email:
    'Potvrzujete odeslání e-mailu s pozvánkou',
  view_week_plan: 'Zobrazit týdenní degustace',
  are_you_confirming_to_send_the_confirmation_email:
    'Potvrzujete odeslání potvrzovacího e-mailu?',
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation:
    'Každých 10 minut se aktualizuje e-mailová schránka s odpověďmi pro plánované degustace.',
  documents_upload_tips: 'Nahrávání souborů podporuje pouze {{field}}',
  ignore_submit: 'Ignorovat&Odeslat',
  if_count_as_kpi:
    'Pokud je to nutné pro výpočet BSSI a GBSI, nezapomeňte u níže uvedených vzorových klíčových ukazatelů výkonnosti  (KPI) ‘Počítat jako klíčový ukazatel výkonnosti (KPI)’',
  confirmed_count: 'Potvrzený počet',
  accepted: 'Přijato',
  declined: 'Odmítnuto',
  no_response: 'Bez odpovědi',
  apply_to_all_sessions: 'Použít pro všechny degustace',
  reminder_time: 'Čas připomenutí',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    'Jste si jisti, že chcete odstranit vybraný čas zahájení/ukončení degustace a změnit na jiný termín.',
  apply_to_all_sessions_location_tasters:
    'Použít ‘Místo’ a ‘Degustátory’ na následující sezení',
  upload_tasters: 'Nahrát ochutnávky',
  mcs_tasting: 'Ochutnávka KPI',
  qcs_tasting: 'Ochutnávka KPI',
  mcs_tasting_tips:
    'Pokud toto kolo obsahuje vzorky MCS/KPI, systém použije související kód KPI podle značky vzorku.',
  round_samples_shuffle_confirm: 'Určitě chcete zamíchat sady?',
  all_count_as_kpi: 'Vše se počítá jako KPI',
  msc_tasting_tour_mask:
    'Systém automaticky identifikuje související KPI kód na základě spočítaného vzorku se správným KPI měsícem, takže nemusíte rozdělovat různé značky v jednom kole.',
  competition: 'Soutěž',
  copy_link: 'Kopírovat odkaz',
  open_link: 'Otevřít odkaz',
  common_download_img: 'Stáhnout IMG',
  please_select_taster: 'Vyberte si prosím své jméno',
  qr_code: 'QR kód',
  global_id: 'Globální ID',
  user_principal_name: 'Jméno hlavního uživatele',
  user_status: 'Stav uživatele',
  termination_date: 'Datum ukončení',
  function_level: 'Úroveň funkce',
  last_update_time: 'Čas poslední aktualizace',
  system_related: 'Související systém',
  workday_related: 'WorkDay Související',
  employee_id: 'ID zaměstnance',
  zitec_project_name: 'Název projektu',
  applicant: 'Žadatel',
  applicant_date: 'Datum žádosti',
  test_method: 'Zkušební metoda',
  liquid_category: 'Kategorie kapalin',
  conditions: 'Podmínky',
  time_points: 'Časové body',
  execution_date: 'Datum provedení',
  execution_by_time_points: 'Vypočítané datum provedení podle časových bodů',
  invitation_start_time: 'Čas zahájení pozvánky',
  invitation_end_time: 'Čas ukončení pozvánky',
  invitation_reminder: 'Připomenutí pozvánky',
  application_form: 'Formulář žádosti',
  application_form_result: 'Výsledek formuláře žádosti',
  upload_result: 'Výsledek nahrávání',
  zitec_sessions: 'Zasedání ZITEC',
  zitec_id: 'ZITEC ID',
  new_zitec_session: 'Nové zasedání ZITEC',
  common_search_applicant: 'Hledat žadatele',
  history_record: 'Záznam o historii',
  common_quarterly: 'Čtvrtletní',
  common_month: 'měsíc',
  kpi_report: 'KPI Zpráva',
  kpi_result: 'Soubor Anaplan',
  action_log: 'Akční protokol',
  validate_data: 'Ověřit data',
  push_anaplan_window_open_date: 'Push Anaplan Window Otevřít datum:',
  unLock_kpi: 'Odemknout KPI',
  lock_kpi: 'Uzamknout KPI',
  locked: 'Uzamčeno',
  unlocked: 'Odemčeno',
  menu_kpi_lock: 'KPI uzamčení',
  freshness_kpi_lock: 'Čerstvost uzamčení',
  in_profile_kpi_lock: 'In Profile uzamčení',
  are_you_sure_you_want_to_lock_kpi:
    'Jste si jisti, že chcete uzamknout KPI pro {{field}}',
  are_you_sure_you_want_to_unlock_kpi:
    'Jste si jisti, že chcete odemknout KPI {{field}}',
  lock_kpi_month_zone:
    'Vaše akce je omezena kvůli uzamčení vzorku KPI, který byl aktivní pro daný měsíc a zónu KPI. V případě dotazů se prosím obraťte na vlastníka zóny pro další podrobnosti o uzamčení dat KPI.',
  lock_freshness_kpi_month_zone:
    'Vaše akce je omezena kvůli uzamčení vzorku KPI, který byl aktivní pro dané čtvrtletí a zónu KPI. V případě dotazů se prosím obraťte na vlastníka zóny pro další podrobnosti o uzamčení dat KPI.',
  submit_timeout: 'Odeslání se nezdařilo, zkuste to prosím později!',
  anaplan_un_upload_tips: 'Počkejte prosím na další otevřené okno Anaplanu!',
  anaplan_un_confirm_tips: 'Potvrďte prosím údaje KPI pro daný měsíc!',
  confirmed: 'Potvrzeno',
  confirm_data: 'Potvrzené data',
  flavor_groups: 'Skupiny příchutí',
  compound: 'Složené',
  sit_code_not_exist:
    'Tento kód sedadla neexistuje, dbejte prosím na formát kódu sedadla, například 001, 002.',
  sit_code_chose:
    'Tento kód sedadla byl zvolen, zadejte prosím správný kód sedadla.',
  kpi_lock: 'Zámek KPI',
  kpi_confirmation: 'Potvrzení KPI',
  global_kpi_lock: 'Global KPI Zámek',
  select_month: 'Vyberte měsic',
  need_to_wait_global_lock: 'Musíte počkat na globální uzamčení.',
  monthly_kpi_locked_zones: 'Měsíční KPI Uzamčené zóny',
  flavor_confirm_save: `Nevybraná příchuť '{{field}}' je v přidaných vzorcích. Pokud potvrdíte uložení aktuální konfigurace příchutí, příslušné vzorky budou odstraněny`,
  temporary_admin: 'Dočasný administrátor',
  unhide_sample_details: 'Odkrýt podrobnosti o vzorku',
  hide_sample: 'Skrýt vzorek',
  download_report_timeout_error_message:
    'Timeout přístupu, zkontrolujte prosím síťové připojení',
  you_can_only_select_up_to:
    'Vybrat můžete pouze maximálně {{field}}, prosím snížte počet možností.',
  push_anaplan: 'Push Anaplan',
  pushed: 'Push Completion',
  self_evaluation_report: 'Klikněte pro stažení sebehodnotící zprávy',
  date_range: 'Rozsah dat',
  kpi_month_range: 'KPI Měsíční rozsah',
  quick_select: 'Rychlý výběr',
  current_month: 'Aktuální měsíc',
  current_year: 'Aktuální rok',
  a_whole_year: 'Celý rok',
  download_self_evaluation_report: 'Stáhnout sebehodnotící zprávu',
  select_tasters: 'Vybrat ochutnávače',
  create_ticket: 'Vytvořit ticket',
  sensory_intelligent_platform: 'Inteligentní platforma Sensory - PBI',
  external_links: 'Externí odkazy',
  evaluation_report: 'Hodnotící zpráva',
  download_evaluation_report: 'Stáhnout hodnotící zprávu',
  taster_type: 'Typ ochutnávky',
  taster_evaluation_tip:
    'Nyní si můžete stáhnout zprávu o sebehodnocení kliknutím zde!',
  admin_evaluation_tip:
    'Nyní můžete kliknout zde a stáhnout si hodnotící zprávu degustátorů',
  kpi_sample: 'Ukázka KPI',
  add_to_download_list: 'Přidat do seznamu ke stažení',
  to_download_list: 'Ke stažení',
  selected_tasters: 'Vybrané ochutnávky',
  generation_time: 'Čas generování',
  start_month: 'Začátek měsíce',
  end_month: 'Konec měsíce',
  download_all: 'Stáhnout vše',
  new_physchem_tips:
    'Nyní můžete kliknout sem a přidat fyzikálně-chemické vlastnosti vzorku',
  view_physchem_tips:
    'Nyní můžete kliknout sem a zobrazit fyzikálně-chemické vlastnosti vzorků aktuálního kola',
  physchem_disabled_tips: 'Nelze zobrazit phychem, když jsou vzorky skryté',
  package_code: 'Kód balení',
  concentration_at_fu: 'Koncentrace 1 chuťová jednotka',
  base_beer: 'Základní pivo',
  flavor_intensities_scale: 'Stupnice intenzity chuti',
  flavor_unit: 'Jednotka chuti',
  add_a_sample: 'Přidat vzorek',
  common_kpi_quarter: 'KPI čtvrtletí',
  sample_duplicated_quarter_kpi_message:
    'Pro vybrané čtvrtletí, značku a web již existuje KPI a nebude možné uložit.',
  select_quarter: 'Vyberte čtvrtletí',
  please_select_kpi_quarter: 'Prosím vyberte KPI čtvrtletí',
  error_fields: 'Chybová pole',
  your_answer: 'Vaše odpověď',
  preference: 'Preferenční',
  please_select_preference_group:
    'Před odesláním je třeba vybrat své preference!',
  monthly_report: 'Měsíční zpráva',
  draft: 'Návrh',
  confirm_send: 'Potvrdit a odeslat',
  sent_completion: 'Odesláno Dokončeno',
  send_draft: 'Odeslat návrh',
  send_draft_monthly_report:
    'Odeslat měsíční zprávu na vaši e-mailovou adresu.',
  please_confirm_the_recipients: 'Potvrďte příjemce měsíční zprávy',
  total_recipients: 'Celkový počet příjemců',
  sending: 'Odesílání',
  sending_monthly_report_tips1: `Vaše žádost se právě zpracovává.`,
  sending_monthly_report_tips2: `Výsledek zkontrolujte v „Akční protokol“.`,
  configure_upgrade_center: 'Nakonfigurovat centrum aktualizací',
  sprint_content: 'Obsah sprintu',
  release_date: 'Datum vydání',
  add_sprint: 'Přidat sprint',
  sprint_meterials: 'Materiály sprintu',
  upgrade_center: 'Centrum aktualizací',
  function: 'Funkce',
  my_evaluation_report: 'Můj hodnotící zpráva',
  upgrade_center_remove_sprint_number:
    'Opravdu chcete odstranit toto číslo sprintu',
  sprint_version_tips: 'Kliknutím zobrazíte materiály sprintu.',
  edit_sprint: 'Upravit sprint',
  new_sprint_tips: 'Nyní můžete kliknout sem a zobrazit materiály ke sprintu.',
  production_date_range: 'Rozsah dat výroby',
  quality: 'Kvalita',
  preparation: 'Příprava',
  panel: 'Panel',
  session: 'Seance',
  product: 'Produkt',
  attribute: 'Atribut',
  common_menu_samples: 'Vzorky',
  common_menu_rounds: 'Kola',
  common_menu_groups: 'Skupiny',
  common_menu_suspension_list: 'Pozastavení',
  common_menu_planning_week_sessions: 'Plánovací týdenní relace',
  common_menu_zitec_sessions: 'ZITEC relace',
  common_menu_brands: 'Značky',
  common_menu_kpi_brands: 'KPI značky',
  common_menu_packages: 'Balíčky',
  common_menu_styles: 'Styly',
  common_menu_malt_variety: 'Odrůda jęčmenů',
  common_menu_intensities: 'Intenzity',
  common_menu_categories: 'Kategorie',
  common_menu_attributes: 'Atributy',
  common_menu_user_management: 'Správa uživatelů',
  common_menu_role_management: 'Správa rolí',
  common_menu_permission_control: 'Řízení oprávnění',
  system: 'Systém',
  select_taste_type: 'Vybrat typ ochutnávky',
  select_round: 'Vybrat kolo',
  a_previous_request_is_still_being_processed:
    'Předchozí požadavek se stále zpracovává. Zkuste to prosím později znovu.',
  select_item: 'Vybrat {{field}}',
  common_new_kpi_brand_button: 'Nová KPI brand',
  common_target: 'Cíl',
  common_focus_brands: 'Fokusní značky',
  common_strategic_brands: 'Strategické značky',
  kpi_brands_new_page_description:
    'Rozhraní pro vytvoření nové KPI značky, s funkcemi pro vyplnění informací o KPI značce, odeslání a uložení.',
  kpi_brands_edit_page_description:
    'Úprava rozhraní KPI Brand, s funkcemi pro aktualizaci, odeslání a uložení informací KPI Brand.',
  kpi_brands_edit_page_description_prefix:
    'Zobrazit a konfigurovat KPI Brands pro ',
  kpi_brands_page_description:
    'Rozhraní pro správu KPI značek, s funkcemi pro zobrazení, odeslání a kontrolu.',
  table_apply: 'Použít',
  table_clear: 'Vymazat',
  table_search: 'Hledat',
  table_enter_to_filter: 'Zadejte pro filtrování...',
  table_select_to_filter: 'Vyberte pro filtrování...',
  table_select_all: 'Vybrat vše',
  table_select_all_aria: 'Vybrat všechny řádky',
  table_select_row_aria: 'Vybrat řádek',
  table_filter_by: 'Filtrovat podle',
  table_clear_filters: 'Vymazat filtry',
  table_reset_filters: 'Obnovit filtry',
  table_no_results_for_filters: 'Pro použité filtry nebyly nalezeny žádné výsledky.',
  table_items_selected: 'vybraných položek',
  table_sort: 'Seřadit',
  table_sort_toggle: 'Kliknutím přepnete řazení',
  table_no_options: 'Žádné dostupné možnosti',
  table_reset: 'Resetovat',
  table_all: 'Vše',
  table_no_results: 'Nebyly nalezeny žádné výsledky pro použité filtry',
  common_approved_at: 'Schváleno {{date}}',
  common_rejected_at: 'Zamítnuto {{date}}',
  kpi_status_created: 'Vytvořeno',
  kpi_status_waiting_for_approval: 'Čeká na schválení',
  kpi_status_approved: 'Schváleno',
  kpi_status_rejected: 'Zamítnuto',
  kpi_action_approve: 'Schválit',
  kpi_action_reject: 'Zamítnout',
  common_by_user: 'od {{user}}',
  pagination_aria_label_next_page: 'Přejít na další stránku',
  pagination_aria_label_previous_page: 'Přejít na předchozí stránku',
  pagination_aria_label_first_page: 'Přejít na první stránku',
  pagination_aria_label_last_page: 'Přejít na poslední stránku',
  pagination_aria_label_input:
    'Zadejte požadovanou stránku, od 1 do {totalItems}',
  pagination_aria_label_items_per_page:
    'Vybráno {pageSize} položek na stránku, klikněte pro změnu',
  pagination_lines_per_page: 'Řádků na stránku',
  pagination_total_pages: 'z {totalPages}',
  pagination_total_elements: '{firstItem}-{lastItem} z {totalItems} výsledků',
  pagination_no_results: 'Nebyly nalezeny žádné výsledky',
  kpi_brand_successfully_saved: 'KPI brand úspěšně uložena!',
  kpi_brand_saved_description:
    'Zkontrolujte ji v KPI brand níže. Toto je pouze dočasné uložení, schvalovací podání ještě nebylo dokončeno.',
  kpi_brand_failed_to_save: 'Uložení KPI brand se nezdařilo.',
  kpi_brand_save_failed_description: 'Zkuste to prosím znovu za chvíli.',
  kpi_brand_successfully_submitted: 'KPI brand úspěšně vytvořena!',
  kpi_brand_submitted_description:
    'Zkontrolujte ji v KPI brand níže. Zkontrolujte prosím průběh schvalování na stránce s podrobnostmi; tato KPI brand bude k dispozici až po schválení.',
  kpi_brand_failed_to_submit: 'Vytvoření KPI brand se nezdařilo.',
  kpi_brand_submit_failed_description: 'Zkuste to prosím znovu za chvíli.',
  flavor_id_discussion: 'Diskuse o identifikaci příchutí',
  view_and_discussion_for: 'Zobrazit a diskutovat pro',
  common_cup: 'Sklenice',
  tasters_joined: 'Zúčastnění degustátoři',
  tasters_all_correct: 'Degustátoři se vším správně',
  total_accuracy: 'Celková přesnost',
  accuracy: 'Přesnost',
  all_correct: 'Vše správně',
  otherwise: 'Ostatní',
  result: 'Výsledek',
  Key: 'Klíčový',
  nonkey: 'Neklíčový',
  common_guest: 'Host',
  view_correct_answers: 'Zobrazit správné odpovědi',
  hide_correct_answers: 'Skrýt správné odpovědi',
  change_to_table: 'Přepnout na tabulku',
  change_to_card: 'Přepnout na karty',
  not_answered: 'Neodpovězeno',
  actions: 'Akce',
  actions_page_description:
    'Zobrazit všechny Akce vytvořené uživateli během degustační relace.',
  action_created_by: 'Vytvořil(a)',
  my_actions: 'Moje Akce',
  action_list_info: 'Akce bude vytvořena po uzavření kola.',
  unsaved_changes_warning: 'Máte neuložené změny. Opravdu chcete odejít?',
  common_go_back: 'Zpět',
  cancel_create_action_title: 'Zrušit vytvoření akce?',
  cancel_edit_action_title: 'Zrušit úpravu akce?',
  cancel_create_action_confirm: 'Zrušit vytvoření akce',
  cancel_edit_action_confirm: 'Zrušit úpravu akce',
  unsaved_changes_description:
    'Do formuláře jste zadali obsah. Zrušením odstraníte všechny neuložené údaje. Chcete pokračovat?',
  unsaved_changes_edit_description:
    'Upravili jste obsah formuláře. Zrušením odstraníte všechny neuložené změny. Chcete pokračovat?',
  action_update_failed_desc: 'Zkuste to za chvíli znovu.',
  action_change_status_successfully: 'Stav byl změněn!',
  action_change_status_successfully_desc: 'Stav akce byl změněn na {{status}}.',
  action_change_status_failed: 'Stav se nepodařilo změnit',
  action_change_status_failed_desc:
    'Stav akce se nepodařilo změnit. Zkuste to znovu.',
  download_report_success: 'Protokoly byly úspěšně staženy!',
  download_report_success_desc: 'Najdete je ve složce Stažené soubory.',
  download_self_evaluation_report_success:
    'Sebehodnotící zpráva byla úspěšně stažena!',
  download_report_failed: 'Stažení protokolů se nezdařilo.',
  download_report_failed_desc: 'Zkuste to prosím znovu později.',
  evaluation_report_add_success: 'Protokol byl úspěšně přidán!',
  evaluation_report_add_success_desc:
    "Najdete ho v hodnotícím protokolu 'Ke stažení'.",
  evaluation_report_add_failed: 'Protokol se nepodařilo přidat.',
  evaluation_report_add_failed_desc: 'Zkuste to prosím znovu později.',
  add_taster: 'Přidat degustátora',
  alcohol_concentration_result: 'Výsledek koncentrace alkoholu',
  absence_save_success: 'Důvod nepřítomnosti byl úspěšně přidán!',
  absence_save_success_desc: 'Najdete ho v odeslaných nepřítomnostech.',
  submitted_absence: 'Odeslané nepřítomnosti',
  no_absence_to_show: 'Žádné nepřítomnosti k zobrazení',
  no_more_data: 'Žádná další data',
  absence_delete_success: 'Důvod nepřítomnosti byl úspěšně odstraněn!',
  absence_delete_success_desc: 'Aktualizovaný seznam najdete v odeslaných nepřítomnostech.',
  absence_delete_confirm_title: 'Odstranit nepřítomnost?',
  absence_delete_confirm_description: 'Záznam nepřítomnosti [{{start}} - {{finish}}] bude trvale odstraněn. Chcete pokračovat?',
  absence_delete_confirm_delete: 'Odstranit',
  absence_save_failed: 'Důvod nepřítomnosti se nepodařilo přidat',
  absence_save_failed_desc: 'Zkuste to prosím znovu později.',
  absence_duplicate_date_desc:
    'Záznam o nepřítomnosti pro vybrané datum již existuje. Duplicitní odeslání není povoleno.',
  absence_delete_failed: 'Důvod nepřítomnosti se nepodařilo odstranit',
  absence_delete_failed_desc: 'Zkuste to prosím znovu později.',
  role_management_change_role: 'Změnit roli',
  role_management_reset_success: 'Oprávnění byla úspěšně obnovena!',
  role_management_reset_success_desc: 'Oprávnění této role byla obnovena na výchozí konfiguraci. Můžete je zkontrolovat níže v ovládacím panelu oprávnění.',
  role_management_reset_failed: 'Oprávnění se nepodařilo obnovit.',
  role_management_reset_failed_desc: 'Zkuste to prosím znovu později.',
  role_management_switch_role_title: 'Zahodit změny?',
  role_management_switch_role_description: 'Existují neuložené změny oprávnění. Přepnutím role budou zahozeny. Chcete pokračovat?',
  role_management_switch_role_confirm: 'Změnit roli',
  role_management_created: 'Vlastní role byla úspěšně vytvořena!',
  role_management_created_desc: 'Podívejte se na ni v níže uvedeném řízení oprávnění.',
  role_management_permissions_failed: 'Oprávnění se nepodařilo načíst.',
  role_management_create_failed: 'Vytvoření role se nezdařilo.',
  role_management_create_required: 'Zadejte název role a vyberte sadu oprávnění.',
  role_management_create_failed_desc: 'Zkuste to prosím znovu později.',
  role_management_create_duplicate: 'Tento název role již existuje!',
  role_management_create_duplicate_desc: 'Zadejte jiný název role a zkuste to znovu.',
  role_management_save_success: 'Oprávnění role byla úspěšně aktualizována!',
  role_management_save_success_desc: 'Změny byly uloženy. Můžete je zkontrolovat níže v řízení oprávnění.',
  role_management_save_failed: 'Uložení změn role se nezdařilo.',
  role_management_save_failed_desc: 'Zkuste to prosím znovu později.',
  role_management_permission: 'Funkce',
  role_management_view: 'Zobrazit',
  role_management_edit: 'Upravit',
  role_management_approve: 'Schválit',
  role_management_search: 'Hledat role',
  role_management_current_role_prefix: 'Vaše aktuální role je',
  role_management_create: 'Vytvořit vlastní roli',
  role_management_save_changes: 'Uložit změny',
  common_apply: 'Použít',
  role_management_reset_title: 'Obnovit výchozí oprávnění?',
  role_management_reset_tooltip: 'Obnovit oprávnění na konfiguraci role [{{parentRole}}].',
  role_management_reset_description: 'Tím se oprávnění role obnoví na výchozí konfiguraci a odstraní se všechny ruční změny. Tuto akci nelze vrátit zpět.',
  cancel_create_role_title: 'Zrušit vytváření vlastní role?',
  cancel_create_role_confirm: 'Zrušit vytváření role',
  cancel_create_role_description: 'Ve formuláři jsou zadané údaje. Zrušením se všechny neuložené údaje zahodí. Chcete pokračovat?',
  role_management_delete_title: 'Odstranit vlastní roli?',
  role_management_delete_preview:
    '{{role}} bude trvale odstraněna. Uživatelé přiřazení k této roli ztratí přístup ke všem oprávněním, která jsou s ní spojena. Chcete pokračovat?',
  role_management_delete_failed: 'Role se nepodařilo odstranit.',
  role_management_default_role: 'výchozí role',
  role_management_delete_preview_no_users: 'Vlastní role „{{role}}“ bude trvale odstraněna. Chcete pokračovat?',
  role_management_create_title: 'Vytvořit vlastní roli',
  role_management_role_name: 'Název role',
  role_management_permission_set: 'Nastavit vlastní oprávnění na základě',
  role_management_role_name_placeholder: 'Zadejte název role',
  role_management_permission_set_placeholder: 'Vyberte základní roli',
  role_management_reset_success: 'Oprávnění byla úspěšně obnovena!',
  role_management_reset_success_desc: 'Oprávnění této role byla obnovena na výchozí konfiguraci. Můžete je zkontrolovat níže v ovládacím panelu oprávnění.',
  role_management_reset_failed: 'Oprávnění se nepodařilo obnovit.',
  role_management_reset_failed_desc: 'Zkuste to prosím znovu později.',
};
